export default __webpack_public_path__ + "static/media/Caveman.65f556be.ttf";